import gql from 'graphql-tag';

/**
 * Mutation to set or clear the custom name of an inspection instance.
 * Passing a null customName clears the name.
 */
export const setInspectionInstanceCustomNameMutation = gql`
  mutation setInspectionInstanceCustomName(
    $instanceId: UUID!
    $channelId: UUID!
    $customName: String
    $setAt: DateTime!
  ) {
    setInspectionInstanceCustomName(
      instanceId: $instanceId
      channelId: $channelId
      customName: $customName
      setAt: $setAt
    ) {
      success
      newVersion
    }
  }
`;
